'use client';

import React from 'react';
import { NavigationControls, NavigationControlsProps } from './NavigationControls';
import { ItemsPerPageSelector } from './ItemsPerPageSelector';

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  variant?: 'jumper' | 'default';
  className?: string;
  showItemsPerPageSelector?: boolean;
  onScrollToTop?: () => void;
  navigationControlsClassNames?: NavigationControlsProps['classNames'];
  hideOnSinglePage?: boolean;
}

export function Pagination({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  variant = 'default',
  className,
  showItemsPerPageSelector = true,
  onScrollToTop,
  navigationControlsClassNames,
  hideOnSinglePage = true,
}: PaginationProps) {
  if (totalPages === 0 || (hideOnSinglePage && totalPages === 1)) {
    return null;
  }

  return (
    <div className={`flex items-center justify-center gap-2 flex-wrap ${className}`}>
      <NavigationControls
        classNames={navigationControlsClassNames}
        currentPage={currentPage}
        totalPages={totalPages}
        variant={variant}
        onPageChange={onPageChange}
        onScrollToTop={onScrollToTop}
        hideOnSinglePage={hideOnSinglePage}
      />
      {showItemsPerPageSelector && (
        <ItemsPerPageSelector itemsPerPage={itemsPerPage} onItemsPerPageChange={onItemsPerPageChange} />
      )}
    </div>
  );
}
